import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { UserToCommissionActionTypes } from '../State/actions/user-to-commission.action';
import { getUserToCommissionFetched, getUserToCommissionLatestUpdatedAt } from '../State/selectors/user-to-commission.selector';
import { BaseEntityReloadResolver2 } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class UserToCommissionResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getUserToCommissionFetched, getUserToCommissionLatestUpdatedAt, UserToCommissionActionTypes.Load, store);
    }
}
